import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/** A person's review, independent of the automatically recorded call outcome.
 * The call ID is also the Mongo _id: at most one current review per call. */
@Entity()
export class CallSuccessReview extends MongoEntity {
  static override _class = 'CallSuccessReview';
  static override _collectionName = 'call_success_reviews';

  constructor(data: PartialEntityData<CallSuccessReview>) {
    super(data);
  }

  @Field(() => String) callID: Maybe<string>;
  @Field(() => String) status: Maybe<string>;
  @Field(() => Date) updatedAt: Maybe<Date>;
  @Field(() => String) updatedBy: Maybe<string>;
}
